import { lazy } from "react"

const IntegrationPage$$__react__lazy__component = lazy(() => 
    import("./IntegrationPage__original__module.mjs")
        .then(module => module.get_$$IntegrationPage$$IntegrationPage$$react__component$$2lq8hmtj3jksl())
        .then(component => ({ default: component }))
)

export const get_$$IntegrationPage$$IntegrationPage$$react__component$$2lq8hmtj3jksl = () => IntegrationPage$$__react__lazy__component